export function set_tracking_error(vm, message) {
    vm.tracking_error = message;
}

export function handle_tracking_response(vm, parsed_response) {
    if (parsed_response?.status && parsed_response.status !== "success") {
        set_tracking_error(vm, parsed_response?.message || "Failed to load signer tracking.");
        return;
    }

    vm.tracking_response = parsed_response;
}

export function get_tracking_error_message(vm, error) {
    const response_payload = vm.parse_response_data(error?.response?.data);
    return response_payload?.message || error?.message || "Failed to load signer tracking.";
}
